export enum STORE_FILTERS {
  SEARCH = "name",
  IS_ACTIVE = "isActive",
  IS_STARTING_SOON = "isStartingSoon",
  IS_ARCHIVE = "isArchive",
}
